import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { FileType } from '../file-type';
import { HttpService } from '../service/http.service';
import { SchoolFile } from '../school-file';
import { SchoolService } from '../service/school.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-school-file-upload',
  templateUrl: './school-file-upload.component.html',
  styleUrls: ['./school-file-upload.component.css']
})
export class SchoolFileUploadComponent implements OnInit {

  files: SchoolFile[] = [];
  schoolFileForm!: FormGroup;
  fileTypes: FileType[] = [];

  @ViewChild("fileUploadRef") fileUploadRef: any;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    public schoolService: SchoolService
  ) { }

  ngOnInit(): void {
    this.initFileList();
    this.httpService.getAllFileTypes().subscribe(res => {
      this.fileTypes = res;
    });
  }

  initFileList(){
    this.schoolFileForm = this.builder.group({
      fileDetails: this.builder.array([])
    });
    this.httpService.getSchoolFilesBySchoolId(this.schoolService.selectedSchoolId).subscribe(files => {
      this.files = files;
      this.populateData();
    });
  }

  get schoolFiles(): FormArray{
    return this.schoolFileForm.get("fileDetails") as FormArray;
  }

  uploadFiles(event: any){
    let formData = new FormData();
    for(let file of event.files){
      formData.append("files", file);
    }
    this.httpService.postSchoolFiles(formData, this.schoolService.selectedSchoolId).subscribe(() => {
      this.toastService.addSuccess("Success", "File(s) uploaded");
      this.fileUploadRef.clear();
      this.initFileList();
    });
  }

  schoolFilesControls(index: number){
    return this.schoolFiles.controls[index];
  }

private populateData(){
  this.files.forEach((data, index) => {
    this.addFileToFormArray();
    this.schoolFilesControls(index).get("name")!.setValue(data.name);
    this.schoolFilesControls(index).get("comment")!.setValue(data.comment);
    this.schoolFilesControls(index).get("id")!.setValue(data.id);
    this.schoolFilesControls(index).get("schoolId")!.setValue(data.schoolId);
    this.schoolFilesControls(index).get("fileType")!.setValue(data.fileType);
    this.schoolFilesControls(index).get("needsToBeCompleted")!.setValue(data.needsToBeCompleted);
  });
}

  addFileToFormArray(){
    this.schoolFiles.push(this.builder.group({
      name: "",
      comment: "",
      id: null,
      schoolId: null,
      fileType: null,
      needsToBeCompleted: false
    }));
  }

  downloadFile(formGroup: FormGroup){
    this.httpService.getSchoolFileById(formGroup.value.id).subscribe(res => {
      let binaryData = [];
      binaryData.push(res);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
      downloadLink.setAttribute('download', formGroup.value.name);
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }, error => this.toastService.addError("Error", error.message));
  }

  deleteFile(formGroup: FormGroup){
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this file?",
      accept: () => {
        this.httpService.deleteSchoolFileById(formGroup.value.id).subscribe(() => {
          this.initFileList();
          this.toastService.addSuccess("Success", "File deleted");
        }, error => this.toastService.addError("Error", error.message));
      }
    });
  }

  submitAll(){
    if(this.schoolFiles.length == 0){
      this.toastService.addError("Error", "There is no file to update or create");
      return;
    }
    let observables = [];
    for(let form of this.schoolFiles.controls){
      if(form.invalid){
        this.toastService.addError("Error", "Please check the form value");
        return; 
      }
      observables.push(
        this.httpService.updateSchoolFile(new SchoolFile(
          form.value.id,
          form.value.name,
          form.value.schoolId,
          form.value.comment,
          form.value.fileType,
          form.value.needsToBeCompleted
        ))
      );
    }
    const results = forkJoin(observables);
    results.subscribe({
      complete: () => {
        this.toastService.addSuccess("Success", "Update successfull");
      },
      error: error => this.toastService.addError("Error", error.message)
    });
  }


}
